/*
 * Click & collect: which days a customer can collect on. The order day never
 * counts; the first day is the 3rd working day after it; Monday to Friday only;
 * no bank holidays; up to 28 days ahead (brief 24 Sep, Suzie/Tom 28 Sep).
 * Pure: `todayIso` is the UK calendar date (YYYY-MM-DD) of "now", computed by the caller.
 */
(function (root) {
  function iso(d) { return d.toISOString().slice(0, 10); }
  function collectionDays(todayIso, bankHolidays) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(todayIso))) return [];
    var bh = {};
    (bankHolidays || []).forEach(function (x) { bh[x] = true; });
    var d = new Date(todayIso + 'T12:00:00Z');
    var limit = new Date(d.getTime()); limit.setUTCDate(limit.getUTCDate() + 28);
    var working = 0, out = [];
    while (true) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (d > limit) break;
      var wd = d.getUTCDay();
      if (wd === 0 || wd === 6 || bh[iso(d)]) continue;
      working++;
      if (working >= 3) out.push(iso(d));
    }
    return out;
  }
  // The UK calendar date of `now` as YYYY-MM-DD, built from date parts: formatting with
  // a locale (e.g. en-CA) is not guaranteed to give that shape in every browser.
  function ukTodayIso(now) {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(now || new Date());
    var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
    return get('year') + '-' + get('month') + '-' + get('day');
  }
  var api = { collectionDays: collectionDays, ukTodayIso: ukTodayIso };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.CartFulfilmentDays = api;
})(this);
